import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const IconAndTitleSquaredCard = ({ iconAlt, iconURL, title, subtitle, cardUrl }) => (React.createElement("a", { className: "icon-title-squared-card", href: cardUrl },
    React.createElement(ImgV2, { src: iconURL, alt: iconAlt }),
    React.createElement("p", { className: "icon-title-squared-card__title" }, title),
    React.createElement("p", { className: "icon-title-squared-card__subTitle" }, subtitle)));
